import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
const apiURL = "status-types";

export const getWellStatusTypeList = () => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/${apiURL}`, {
				...AuthHeader,
			})
			.then((_data: any) => {
				if (_data?.data && _data.data.length) {
					resolve(_data.data);
				} else {
					resolve(null);
				}
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const addWellStatusTypeItem = (data: any) => {
	return new Promise((resolve, reject) => {
		axios
			.post(`${url}/${apiURL}/addWellStatusType`, data, AuthHeader)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const updateWellStatusTypeItem = (uuid: any, data: any, prevData: any) => {
	return new Promise((resolve, reject) => {
		axios
			.put(
				`${url}/${apiURL}/updateWellStatusType`,
				{
					filter: { uuid: uuid },
					data: data,
					options: { upsert: true, new: true },
					prevData: prevData,
				},
				AuthHeader
			)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const deleteWellStatusTypeItem = (uuid: any) => {
	return new Promise((resolve, reject) => {
		axios
			.delete(`${url}/${apiURL}/deleteWellStatusType`, {
				params: {
					uuid: uuid,
				},
				...AuthHeader,
			})
			.then((_data) => {
				resolve(true);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};
